export default __webpack_public_path__ + "static/media/themesberg.f3d7e257.svg";